import React from 'react';
import api from '../utils/api';

export interface AppContextType {
  globals: {
    [key: string]: unknown;
  };
  isLoading: boolean;
}

const AppContext = React.createContext<AppContextType | null>(null);

interface AppProviderProps {
  children: React.ReactNode;
}

function AppProvider({ children }: AppProviderProps) {
  const [isLoading, setIsLoading] = React.useState(true);
  const [globals, setGlobals] = React.useState<AppContextType['globals']>({});

  const fetchGlobals = React.useCallback(async () => {
    setIsLoading(true);

    try {
      const result = await api.get('/global');
      setGlobals(result.data);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  React.useEffect(() => {
    fetchGlobals();
  }, [fetchGlobals]);

  const value = React.useMemo(
    () => ({
      globals,
      isLoading,
    }),
    [globals, isLoading],
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export { AppProvider, AppContext };
